<template>
  <TheHeader />
  <el-container>
    <el-main>
      <div class="home_container">
      <div class="home_top">
        <router-link class="top_item"
          :to="{
            path:'/v2/rank/0'
          }"
        >
          <div class="top_left">
            <div class="top_left_time">
              
            </div>
            <div class="top_left_attr">
              智能座舱
            </div>
            <div class="top_left_val">
              {{data && data.review_report_num}}台
            </div>
          </div>
          <div class="top_right">
            <div class="item_icon icon_item_znzc"></div>
          </div>
        </router-link>
        <!-- <router-link class="top_item"
          :to="{
            path:'/drive/rank/0'
          }"
        >
          <div class="top_left">
            <div class="top_left_time">
              
            </div>
            <div class="top_left_attr">
              智能驾驶
            </div>
            <div class="top_left_val">
              {{data && data.driving_report_num}}台
            </div>
          </div>
          <div class="top_right">
            <div class="item_icon icon_item_znjs"></div>
          </div>
        </router-link> -->
        <router-link class="top_item"
          :to="{
            path:'/service/downloads'
          }"
        >
          <div class="top_left">
            <div class="top_left_time">
              
            </div>
            <div class="top_left_attr">
              研究报告
            </div>
            <div class="top_left_val">
              {{data && data.research_report_num}}篇
            </div>
          </div>
          <div class="top_right">
            <div class="item_icon icon_item_yjbg"></div>
          </div>
        </router-link>
        <!-- <router-link class="top_item"
          :to="{
            path:'/service/sales/list'
          }"
        >
          <div class="top_left">
            <div class="top_left_time">
              {{data && data.sales_date && (data.sales_date.slice(0,4)+'年'+data.sales_date.slice(4)+'月')}}
            </div>
            <div class="top_left_attr">
              上牌数据
            </div>
            <div class="top_left_val">
              {{data && data.total_sales && (parseInt(data.total_sales/10000)>1?parseInt(data.total_sales/10000):data.total_sales) || '-'}}万
            </div>
          </div>
          <div class="top_right">
            <div class="item_icon icon_item_spsj"></div>
          </div>
        </router-link> -->
        <div class="top_item top_item_new_car">
          <div class="top_left">
            <div class="top_left_time">
            </div>
            <div class="top_left_attr">
              待上线车型
            </div>
            <div class="top_left_val top_left_car">
              {{data && data.next_report && data.next_report.short_name}}
            </div>
          </div>
          <div class="top_right" v-if="data && data.next_report && data.next_report.model_img">
            <div class="top_right_new_car">
              <img :src="data && data.next_report && data.next_report.model_img">
            </div>
          </div>
        </div>
      </div>
      <div class="home_levels">
        <div class="home_levels_tit">
          智舱评级分布
        </div>
        <div class="home_levels_chart">
          <RatingDistribution 
            :data_list="data && data.all_base_data || []"
          />
        </div>
      </div>
      <div class="home_datas">
        <!-- <div class="home_data_item">
          <div class="home_data_item_tit">
            <div class="home_data_item_tit_left">
              销量数据（量）
            </div>
            <div class="home_data_item_tit_right">
              {{data && ((data.sales_list[data.sales_list.length-1].date.slice(0,4)+'年'+data.sales_list[data.sales_list.length-1].date.slice(4)+'月')+'~'+(data.sales_list[0].date.slice(0,4)+'年'+data.sales_list[0].date.slice(4)+'月'))}}
            </div>
          </div>
          <div class="home_data_item_chart">
            <SalesData 
              :data_list="data && data.sales_list || []"
            />
          </div>
        </div>
        <div class="home_data_item">
          <div class="home_data_item_tit">
            <div class="home_data_item_tit_left">
              智能汽车渗透率（%）
            </div>
          </div>
          <div class="home_data_item_chart">
            <SmartPenetration 
              :data_list="data && data.sales_list || []"
            />
          </div>
        </div> -->
        <div class="home_data_item">
          <div class="home_data_item_tit">
            <div class="home_data_item_tit_left">
              OTA每月更新次数
            </div>
            <div class="home_data_item_tit_right">
              {{data && ((data.ota_list[data.ota_list.length-1].date.slice(0,4)+'年'+data.ota_list[data.ota_list.length-1].date.slice(4)+'月')+'~'+(data.ota_list[0].date.slice(0,4)+'年'+data.ota_list[0].date.slice(4)+'月'))}}
            </div>
          </div>
          <div class="home_data_item_chart">
            <OtaUpdate 
              :data_list="data && data.ota_list || []"
            />
          </div>
        </div>
        <div class="home_data_item">
          <div class="home_data_item_tit">
            <div class="home_data_item_tit_left">
              OTA涉及功能更新次数
            </div>
            <div class="home_data_item_tit_right">
              {{data && ((data.ota_list[data.ota_list.length-1].date.slice(0,4)+'年'+data.ota_list[data.ota_list.length-1].date.slice(4)+'月')+'~'+(data.ota_list[0].date.slice(0,4)+'年'+data.ota_list[0].date.slice(4)+'月'))}}
            </div>
          </div>
          <div class="home_data_item_chart">
            <OtaFunction 
              :data_list="data && data.ota_function || []"
            />
          </div>
        </div>
      </div>
    </div>
    </el-main>
  </el-container>
</template>

<script>
import {
  ref
} from "vue";
import {
  getIndexData
} from "@/api";
import TheHeader from "@/components/common/views/TheHeader.vue";
import RatingDistribution from "@/components/home/RatingDistribution.vue";
// import SalesData from "@/components/home/SalesData.vue";
// import SmartPenetration from "@/components/home/SmartPenetration.vue";
import OtaUpdate from "@/components/home/OtaUpdate.vue";
import OtaFunction from "@/components/home/OtaFunction.vue";

export default {
  name:"home",
  components:{
    TheHeader,
    RatingDistribution,
    // SalesData,
    // SmartPenetration,
    OtaUpdate,
    OtaFunction
  },
  
  setup(){
    const data = ref(null);
    const getIndexDataFn = ()=>{
      getIndexData().then(res=>{
        data.value = res.data;
      })
    }
    getIndexDataFn()
    return {
      data
    }
  }
}
</script>

<style lang="less" scoped>
  .el-main{
    background: #fafafa;
  }
  .home_container{
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    .home_top{
      width: 1200px;
      height: 149px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(235, 235, 235);
      border-radius: 10px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      padding-top: 6px;
      .top_item{
        flex:1;
        height: 111px;
        border-left: solid 1px #e4e4e4;
        display: flex;
        justify-content: center;
        &:first-child{
          border: none;
        }
        &.top_item_new_car{
          padding-left: 37px;
          justify-content: space-between;
          .top_right{
            margin-left: 0;
            .top_right_new_car{
              width: 120px;
              height: 100px;
              overflow: hidden;
              margin-top: 20px;
              img{
                width: 180px;
                height: 100px;
                object-fit: contain;
              }
            }
          }
        }
        .top_left{
          min-width: 80px;
          .top_left_time{
            height: 18px;
            font-size: 12px;
            line-height: 18px;
            color: #ff615a;
            letter-spacing: 1px;
          }
          .top_left_attr{
            height: 28px;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: 1px;
            color: #767a9e;
          }
          .top_left_val{
            height: 37px;
            color: #313131;
            font-size: 28px;
            font-weight: 500;
            line-height: 37px;
            letter-spacing: 1px;
            &.top_left_car{
              font-size: 20px;
              white-space: nowrap;
            }
          }
        }
        .top_right{
          align-self: center;
          padding-left: 17px;
          .item_icon{
            width: 53px;
            height: 53px;
            background: #ccc;
            &.icon_item_znzc{
              background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/znzc_20230313.jpg) no-repeat center center;
              background-size: 100%;
            }
            &.icon_item_znjs{
              background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/znjs_20230313.jpg) no-repeat center center;
              background-size: 100%;
            }
            &.icon_item_yjbg{
              background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/yjbg_20230313.jpg) no-repeat center center;
              background-size: 100%;
            }
            &.icon_item_spsj{
              background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/spsj_20230313.jpg) no-repeat center center;
              background-size: 100%;
            }
          }
        
        }
      }
    }
    .home_levels{
      width: 1200px;
      height: 494px;
      border: 1px solid #ebebeb;
      background: #fff;
      border-radius: 10px;
      margin-top: 25px;
      padding: 40px 27px 0;
      .home_levels_tit{
        height: 27px;
        line-height: 27px;
        font-size: 18px;
        color: #767a9e;
        letter-spacing: 1px;
      }
      .home_levels_chart{
        margin-top: 50px;
      }
    }
    .home_datas{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .home_data_item{
        width: 590px;
        height: 406px;
        border: 1px solid #ebebeb;
        background: #fff;
        border-radius: 10px;
        margin-top: 25px;
        padding: 30px 25px;
        .home_data_item_tit{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .home_data_item_tit_left{
            color: #767a9e;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 1px;
          }
          .home_data_item_tit_right{
            color: #767a9e;
            font-size: 14px;
            line-height: 21px;
            letter-spacing: 1px;
          }
        }
        .home_data_item_chart{
          margin-top: 28px;
        }
      }
    }
  }
</style>